module.exports = __webpack_public_path__ + "static/img/video_icon4_2.b356eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon4_2.png
// module id = rp7C
// module chunks = 0